import { createFileRoute } from "@tanstack/react-router";
import { GameBuilder } from "./-components/game-builder";

export const Route = createFileRoute(
  "/_authenticated/_subscribed/_main/game-builder/",
)({
  component: CreateNewGameRouteComponent,
});

function CreateNewGameRouteComponent() {
  return (
    <GameBuilder
      initialValues={{
        name: "",
        description: "",
        shared: false,
        media: {
          tags: ["nsfw"],
          mediaTypes: ["video"],
        },
        splash: {
          id: "",
          photo: "",
          downloadLink: "",
          author: {
            name: "",
            profile: "",
          },
        },
      }}
    />
  );
}
